// Shop this in your style - tracking
(() => {
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.accordion-tab');

    if (!tab) {
      return;
    }

    const league = tab.getAttribute('data-show') || tab.textContent.trim();

    gtag('event', 'shop_style_tab_click', {
      tab_name: league,
      content_type: 'sports_league'
    });
  });
})();